import { Row } from "react-bootstrap";
import exclamation from "../../../../assets/images/exclamation-circle.png";
import { Switch } from "antd";
const Securite = () => {
   const onChange = (checked: Boolean) => {
    console.log(`switch to ${checked}`);
  };
return(
    <Row>
  <div className=" px-3">
  {/* Section des paramètres visibles si isOpenS est vrai */}
  <div
              style={{
                padding: "5px",
                backgroundColor: "#FFFFFF",
                border: "1px solid #E3E3E3",
                boxShadow: "0px 2px 8px rgba(0, 0, 0, 0.1)",
              }}
            >
            <span  className="securite-title" style={{
            marginLeft:'15px',
            width: "100%",
            backgroundColor: "#FFFFFF",
            fontFamily: "Poppins",
            fontSize: "20px",
            fontWeight: "500",
            color: "#070707",
            borderColor: "#0000001A",
            height: "40px",
          }}> Authentification et accès
          </span>
  </div> 
    <div
     className="securite-card" 
      style={{
      padding: "20px",
      backgroundColor: "#FFFFFF",
      border: "1px solid #E3E3E3",
      boxShadow: "0px 2px 8px rgba(0, 0, 0, 0.1)",
      }}
    >
    <div  className="d-flex securite-flex-row" style={{  display: "flex", alignItems: "center", gap: "10px" }}>
      <div 
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between", // le label à gauche, le switch à droite
        width: "100%", // pour occuper toute la ligne si besoin
      }}
    >
      <label
       className="securite-label"
        htmlFor="Pourlesmontantsélevés"
        style={{
          fontFamily: "Poppins",
          fontSize: "18px",
          fontWeight: "400",
          color: "#141414",
          cursor: "pointer",
        }}
      >
        Google Authentificator
      </label>

      <Switch defaultChecked onChange={onChange} style={{transform: "scale(0.8)"}} />
    </div>
  </div>
  <span style={{color:"#07070773",fontSize:"14px",fontWeight:'400',fontFamily:'Poppins'}}>Obligatoire pour tous les marchands</span>
      <div className="row" style={{ display: "flex", gap: "15px",marginTop:'15px' }}>
        {/* Premier input */}
        <div className="col">
          <label
          className="securite-label"
            style={{
              fontFamily: "Poppins",
              fontSize: "18px",
              fontWeight: "400",
              color: "#141414",
            }}
          >
           Délai d’expiration de session (minutes)
          </label>
          <input
          
            type="text"
            placeholder="30"
            className="form-control securite-input"
            style={{
              marginTop:'10px',
              fontSize:'15px',
              color:"#000000",
              backgroundColor: "#FFFFFF",
              borderColor: "#0000001A",
              height: "40px",
              fontFamily: "Poppins",
            }}
          />
        </div>
      </div>

    </div>
  <div
  style={{
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-start",
    marginTop: "25px",
    width: "100%",
  }}
>
</div>
</div>
  <div className=" px-3">
  {/* Section des paramètres visibles si isOpenS est vrai */}
  <div
              style={{
                padding: "20px",
                backgroundColor: "#FFFFFF",
                border: "1px solid #E3E3E3",
                boxShadow: "0px 2px 8px rgba(0, 0, 0, 0.1)",
              }}
            >
            <span style={{
            width: "100%",
            backgroundColor: "#FFFFFF",
            fontFamily: "Poppins",
            fontSize: "20px",
            fontWeight: "500",
            color: "#070707",
            borderColor: "#0000001A",
            height: "40px",
          }}> Politiques de mot de passe
          </span>
  </div> 
    <div
      style={{
      padding: "20px",
      backgroundColor: "#FFFFFF",
      border: "1px solid #E3E3E3",
      boxShadow: "0px 2px 8px rgba(0, 0, 0, 0.1)",
      }}
    >
      <div className="row" style={{ display: "flex", gap: '15px' }}>
        {/* Premier input */}
        <div className="col">
          <label
          className="securite-label"
            style={{
              fontFamily: "Poppins",
              fontSize: "18px",
              fontWeight: "400",
              color: "#141414",
            }}
          >
           Longueur minimale du mot de passe (caractéres)
          </label>
          <input
            type="text"
            placeholder="8"
            className="form-control securite-input"
            style={{
              marginTop:'10px',
              fontSize:'15px',
              color:"#000000",
              backgroundColor: "#FFFFFF",
              borderColor: "#0000001A",
              height: "40px",
              fontFamily: "Poppins",
            }}
          />
        </div>
      </div>
 <div d-flex securite-flex-row style={{  display: "flex", alignItems: "center", gap: "10px",marginTop:'10px' }}>
      <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        width: "100%",
      }}
    >
      <label
      className="securite-label"
        htmlFor="Pourlesmontantsélevés"
        style={{
          fontFamily: "Poppins",
          fontSize: "18px",
          fontWeight: "400",
          color: "#141414",
          cursor: "pointer",
        }}
      >
       Caractères spéciaux obligatoire
      </label>

      <Switch defaultChecked onChange={onChange} style={{transform: "scale(0.8)"}}/>
    </div>
  </div>
  <span style={{color:'#07070773',fontWeight:'400',fontSize:'14px',fontFamily:'Poppins'}}>@, #, $, %, etc</span>
   <div style={{  display: "flex", alignItems: "center", gap: "10px" }}>
      <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between", // le label à gauche, le switch à droite
        width: "100%", // pour occuper toute la ligne si besoin
      }}
    >
      <label
      className="securite-label"
        htmlFor="Pourlesmontantsélevés"
        style={{
          fontFamily: "Poppins",
          fontSize: "18px",
          fontWeight: "400",
          color: "#141414",
          cursor: "pointer",
        }}
      >
       Chiffres obligatoire
      </label>

      <Switch defaultChecked onChange={onChange} style={{transform: "scale(0.8)"}} />
    </div>
  </div>
  <span style={{color:'#07070773',fontWeight:'400',fontSize:'14px',fontFamily:'Poppins'}}>Au moins un chiffre</span>
  </div>
  {/* Bouton Sauvegarder */}
  <div
  className="securite-actions"
  style={{
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-start",
    marginTop: "25px",
    width: "100%",
  }}
>
  {/* BLOC D'AVERTISSEMENT À GAUCHE */}
  <div
      className="btn btn-primary securite-warning"
    style={{
      display: "flex",
      alignItems: "flex-start",
      padding: "10px 15px",
      minHeight: "40px",
      backgroundColor: "#DD20250A",
      borderColor: "#DD20250A",
      borderRadius: "8px",
      fontFamily: "Poppins",
      fontSize: "15px",
      fontWeight: "500",
      boxShadow: "0px 3px 8px rgba(0, 0, 0, 0.1)",
      maxWidth: "450px",
    }}
  >
    {/* Icône */}
    <img
      src={exclamation}
      alt="exclamation"
      style={{
        width: "22px",
        height: "22px",
        marginTop: "3px",
        marginRight: "8px",
      }}
    />
    <div style={{ display: "flex", flexDirection: "column" }}>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: "6px",
        }}
      >
        <span
          style={{
            fontWeight: "600",
            fontSize: "15px",
            lineHeight: "18px",
            color: "#0E0E0FE5",
          }}
        >
          Attention 
        </span>
      </div>
      <span
        style={{
          fontSize: "13px",
          color: "#555",
          lineHeight: "18px",
          marginTop: "2px",
        }}
      >
        Certains changements peuvent affecter
      </span>
      <span
        style={{
          fontSize: "13px",
          color: "#555",
          lineHeight: "18px",
          marginTop: "2px",
        }}
      >
         les opérations en cours.
      </span>
    </div>
  </div>

  {/* BOUTONS À DROITE */}
  <div  className="securite-buttons" style={{ display: "flex", alignItems: "center", gap: "10px",  marginTop: "20px", }}>
    <button
      type="button"
      className="btn btn-primary"
      style={{
        height: "40px",
        color: "#3761FF",
        backgroundColor: "#F2F5FF",
        borderColor: "#F2F5FF",
        borderRadius: "8px",
        fontFamily: "Poppins",
        fontSize: "15px",
        fontWeight: "500",
        padding: "0 15px",
        boxShadow: "0px 3px 8px rgba(0, 0, 0, 0.1)",
      }}
    >
      Réinitialiser
    </button>

    <button
    
      type="button"
      className="btn btn-primary"
      style={{
        height: "40px",
        color: "#FFFFFF",
        backgroundColor: "#3761FF",
        borderColor: "#3761FF",
        borderRadius: "8px",
        fontFamily: "Poppins",
        fontSize: "15px",
        fontWeight: "500",
        padding: "0 15px",
        boxShadow: "0px 3px 8px rgba(0, 0, 0, 0.1)",
      }}
      >
      Enregistrer
    </button>
  </div>
</div>


</div>
    </Row>
);
};
export default Securite;
